import { OktaAuth } from '@okta/okta-auth-js'
import { useAppStore } from '../../stores/appStore'
import { OauthOption } from '../../types/auth/oauthOption'

const oktaIssuer = import.meta.env.VITE_OKTA_DOMAIN
const oktaClientId = import.meta.env.VITE_OKTA_CLIENT_ID
const clientName = import.meta.env.VITE_AIDA_LIBRARY_CLIENT_NAME
const oktaRedirectUri = import.meta.env.VITE_OKTA_REDIRECT_URI || window.location.origin

const isOktaEnvConfigured = Boolean(oktaIssuer && oktaClientId)

const oktaAuth = isOktaEnvConfigured
  ? new OktaAuth({
      issuer: oktaIssuer,
      clientId: oktaClientId,
      redirectUri: oktaRedirectUri,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
      pkce: false,
    })
  : null

export function isOktaConfigured(): boolean {
  const appStore = useAppStore()
  const hasOktaOption = appStore.configuration?.login?.oauthOptions?.includes(OauthOption.Okta)
  return Boolean(isOktaEnvConfigured && hasOktaOption)
}

export async function signInWithOktaAsync(): Promise<void> {
  const appStore = useAppStore()
  const hasOktaOption = appStore.configuration?.login?.oauthOptions?.includes(OauthOption.Okta)

  if (!isOktaEnvConfigured || !oktaAuth || !hasOktaOption) {
    console.error('Okta is not configured.')
    return
  }

  await oktaAuth.token.getWithRedirect({
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    responseType: ['code'],
    state: JSON.stringify({
      client_name: clientName,
    }),
  })
}
